import type { TextInsertVia } from '@/components/canvas/workspace/model/elementInsertTarget';

/** 绘制覆盖层坐标：页内局部 vs 工作区世界 */
export interface DrawOverlayInsertProps {
  insertVia: TextInsertVia;
  pageId?: string;
  /** 局部坐标原点（世界/页面绝对坐标）；页内为 0 */
  originX?: number;
  originY?: number;
  /** 首次落笔时激活目标页 */
  activatePageOnDraw?: boolean;
  /** 会话结束（如工作区单次绘制完成） */
  onSessionEnd?: () => void;
}

export interface FrozenDrawInsertTarget {
  via: TextInsertVia;
  pageId?: string;
  originX: number;
  originY: number;
}

export function toAbsoluteDrawCoords(
  localX: number,
  localY: number,
  originX = 0,
  originY = 0,
): { x: number; y: number } {
  return { x: localX + originX, y: localY + originY };
}
